class GAQueue {
  constructor() {
    this._queue = []
    this._paused = false
    this._processing = false
  }

  pause() {
    this._paused = true
  }

  unpause() {
    this._paused = false
    this.process()
  }

  push(commandArguments) {
    this._queue.push(commandArguments)
  }

  process() {
    // flag to ensure this is not ever done in parallel to ensure the queue stays in order.
    if (this._processing) return
    if (this._paused) return
    if (typeof window === "undefined" || typeof window.ga !== "function") return

    this._processing = true
    while (!this._paused && this._queue.length > 0) {
      this.processArgs(this._queue.shift())
    }
    this._processing = false
  }

  processArgs(args) {
    if (args.length === 1 && typeof args[0] === "function") {
      window.ga(...args[0].call())
    } else {
      window.ga(...args)
    }
  }
}

const ga = (...args) => {
  ga.queue.push(args)
  ga.queue.process()
}

ga.queue = new GAQueue()

export default ga
